import React from 'react'
import PropTypes from 'prop-types'
import ProgressiveImage from 'react-progressive-image'

const Image = ({
  dynamic,
  selectedSex = 'gutt',
  age,
  boySmall,
  boyMedium,
  boyLarge,
  girlSmall,
  girlMedium,
  girlLarge,
  image,
  placeholder,
  description,
  ...rest
}) => {
  if (dynamic) {
    let smallImage
    let mediumImage
    let largeImage

    if (selectedSex === 'gutt') {
      smallImage = boySmall
      mediumImage = boyMedium
      largeImage = boyLarge
    } else {
      smallImage = girlSmall
      mediumImage = girlMedium
      largeImage = girlLarge
    }
    return (
      <ProgressiveImage
        src={age < 4 ? smallImage : age >= 4 && age < 6 ? mediumImage : largeImage}
        placeholder={placeholder || smallImage}
      >
        {src =>
          <img
            className="max-h-75"
            src={src}
            alt={`${selectedSex} ${age} år`}
            {...rest}
          />}
      </ProgressiveImage>
    )
  } else {
    return (
      <ProgressiveImage src={image} placeholder={placeholder || image}>
        {src => <img className="max-h-75" src={src} alt={description} {...rest} />}
      </ProgressiveImage>
    )
  }
}

Image.propTypes = {
  dynamic: PropTypes.bool,
  selectedSex: PropTypes.string,
  age: PropTypes.number,
  boySmall: PropTypes.string,
  boyMedium: PropTypes.string,
  boyLarge: PropTypes.string,
  girlSmall: PropTypes.string,
  girlMedium: PropTypes.string,
  girlLarge: PropTypes.string,
  image: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string
}

export default Image



// WEBPACK FOOTER //
// ./src/components/Image/Image.js